import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import emailValidator from 'foundation/js/inputValidators/emailValidator'
import nameValidator from 'foundation/js/inputValidators/nameValidator'
import phoneValidator from 'foundation/js/inputValidators/phoneValidator'
import { computed, onBeforeMount, ref } from 'vue'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import fieldsConfig from './config/fieldsConfig'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetOpretHoldStepTwo',
    components: {
        FormInputTextField,
        FormCheckbox,
        StafetActions
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const firstName = ref('')
        const lastName = ref('')
        const email = ref('')
        const phone = ref('')
        const consent = ref(false)
        const newsletter = ref(false)
        const readOnly = ref({
            firstName: false,
            lastName: false,
            email: false,
            phone: false,
            consent: false,
            newsletter: false
        })

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_CREATE_A_TEAM
            )

            if (props.userData) {

                if (props.userData.firstName) {
                    firstName.value = props.userData.firstName
                    validateField('firstName', firstName.value)
                    readOnly.value.firstName = true
                    disableValidation('firstName')
                }

                if (props.userData.lastName) {
                    lastName.value = props.userData.lastName
                    validateField('lastName', lastName.value)
                    readOnly.value.lastName = true
                    disableValidation('lastName')
                }

                if (props.userData.email) {
                    email.value = props.userData.email
                    validateField('email', email.value)
                    readOnly.value.email = true
                    disableValidation('email')
                }

                if (props.userData.phoneNumber) {
                    phone.value = props.userData.phoneNumber
                    validateField('phone', phone.value)
                    readOnly.value.phone = true
                    disableValidation('phone')
                }
                
                if (props.userData.consentBool) {
                    consent.value = props.userData.consentBool
                    validateField('consent', consent.value)
                    readOnly.value.consent = true
                    disableValidation('consent')
                }
                
                if (props.userData.newsLetterBool) {
                    newsletter.value = props.userData.newsLetterBool
                    validateField('newsletter', newsletter.value)
                    readOnly.value.newsletter = true
                    disableValidation('newsletter')
                }
            }

            if (storedFields) {
                if (getFieldValue(storedFields, 'phone')) {
                    phone.value = getFieldValue(storedFields, 'phone')
                    validateField('phone', phone.value)
                }

                if (getFieldValue(storedFields, 'consent')) {
                    consent.value = getFieldValue(storedFields, 'consent')
                    validateField('consent', consent.value)
                }

                if (getFieldValue(storedFields, 'newsletter')) {
                    newsletter.value = getFieldValue(storedFields, 'newsletter')
                    validateField('newsletter', newsletter.value)
                }
            }
        })

        const disableValidation = (fieldName) => {
            const field = fieldsConfig.find(field => field.name === fieldName)
            field.validator = _ => true
        }

        const validateField = (fieldName, value) => {
            fieldsConfig.find((item) => item.name === fieldName).value = value
            const field = fieldsConfig.find((field) => field.name === fieldName)
            if (field) {
                field.value = value
                fieldValidator(field)
            }
        }

        const showFirstNameErrorMessage = computed(() => showError('firstName', firstName.value))
        const showLastNameErrorMessage = computed(() => showError('lastName', lastName.value))
        const showEmailErrorMessage = computed(() => showError('email', email.value))
        const showPhoneErrorMessage = computed(() => showError('phone', phone.value))
        const showConsentErrorMessage = computed(() => showError('consent', consent.value))
        const showError = (fieldName, value) => {
            const field = fieldsConfig.find(field => field.name === fieldName)
            return !field.validator(value) && props.displayInputError
        }

        const stepModel = computed(() => {
            return fieldsConfig
        })

        return {
            firstName,
            lastName,
            email,
            phone,
            consent,
            newsletter,
            readOnly,
            showFirstNameErrorMessage,
            showLastNameErrorMessage,
            showEmailErrorMessage,
            showPhoneErrorMessage,
            showConsentErrorMessage,
            stepModel,
            validateField
        }
    }
}
